var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"mousedown":function($event){return _vm.onSelect(_vm.item)},"touchstart":function($event){return _vm.onSelect(_vm.item)}}},[_c('span',[_vm._v(_vm._s(_vm.item.data.postal_code ? `${_vm.item.data.postal_code},` : '')+" "+_vm._s(`${_vm.item.value}`))])])
}
var staticRenderFns = []

export { render, staticRenderFns }